import moment from 'moment'
import {NUMBER_OF_TOP_CARRIERS_TO_SHOW_IN_WIDGET} from './ff-opsdash.constants'
import _ from 'lodash'
import {getLogoByCarrier} from 'config/logo.constant'

interface ITopCarriersData {
    carrier: string
    totalBookings: number
    percentage?: number
    barWidthPercentage?: number
}

export const checkForEmptyActivity = (response: Array<Record<string, any>>) =>
    response.every((item: Record<string, any>) => item.totalBooking === null || parseInt(item.totalBooking) === 0)

export const extractBranchData = (response: Array<Record<string, any>>) => {
    const defaultValues = {
        totalBookingCount: 0,
        maxTotalBooking: 0,
        branchActivityData: [],
        startDate: '',
        endDate: '',
        topCarriersData: []
    }
    if (!response || response?.length === 0) return defaultValues

    const startDate = moment(response[response.length - 1].eventDate).format('MMM DD')
    const endDate = moment(response[0].eventDate).format('MMM DD')

    if (checkForEmptyActivity(response)) {
        return {...defaultValues, startDate, endDate}
    }

    const maxTotalBooking = response.reduce((max, item) => {
        const totalBooking = parseFloat(item.totalBooking)
        return totalBooking > max ? totalBooking : max
    }, 0)

    let totalBookingCount: number = 0
    const carrierSum: Record<string, number> = {}
    let topCarriersData: ITopCarriersData[] = []

    const formattedBranchData = response
        .map((item: Record<string, any>) => {
            let percentage = 0
            const totalBooking = parseInt(item.totalBooking)

            if (!isNaN(totalBooking)) {
                totalBookingCount += totalBooking
                percentage = parseFloat(((totalBooking / maxTotalBooking) * 100).toFixed(1))
            }

            let carrierWiseBookings = null
            if (item.carrierWiseBookings) {
                carrierWiseBookings = item.carrierWiseBookings.map((carrierItem: Record<string, any>) => {
                    const carrier = carrierItem.carrier
                    const numberOfBookings = parseInt(carrierItem.numberOfBookings)

                    if (carrierSum[carrier] === undefined) carrierSum[carrier] = numberOfBookings
                    else carrierSum[carrier] += numberOfBookings

                    return {
                        ...carrierItem,
                        percentage: parseFloat(carrierItem.percentage.toFixed(1))
                    }
                })
            }

            topCarriersData = Object.entries(carrierSum)
                .map(([carrier, totalBookings]) => ({
                    carrier,
                    totalBookings
                }))
                .sort((a, b) => a.totalBookings - b.totalBookings)
                .reverse()

            const formattedDate = moment(item.eventDate).format('MMM DD')
            return {...item, totalBooking, percentage, eventDate: formattedDate, carrierWiseBookings}
        })
        .reverse()

    const maxBookingsByCarrier = topCarriersData[0].totalBookings
    const formattedCarrierData = topCarriersData
        .slice(0, NUMBER_OF_TOP_CARRIERS_TO_SHOW_IN_WIDGET)
        .map((item: ITopCarriersData) => ({
            ...item,
            percentage: parseFloat(((item.totalBookings / totalBookingCount) * 100).toFixed(1)),
            barWidthPercentage: parseFloat(((item.totalBookings / maxBookingsByCarrier) * 100).toFixed(1))
        }))
        .sort((a: ITopCarriersData, b: ITopCarriersData) => {
            if (b.totalBookings !== a.totalBookings) return b.totalBookings - a.totalBookings
            return a.carrier.localeCompare(b.carrier)
        })

    return {
        ...defaultValues,
        totalBookingCount,
        maxTotalBooking,
        branchActivityData: formattedBranchData,
        startDate,
        endDate,
        topCarriersData: formattedCarrierData
    }
}

export const extractTopODPairsData = (response: Record<string, any>) => {
    if (!response || response.length === 0) return []

    const maxTotalBooking = response.reduce((max: number, item: Record<string, any>) => {
        const totalBooking = parseFloat(item.totalBooking)
        return totalBooking > max ? totalBooking : max
    }, 0)

    // Calculate the percentage for each item
    const result = response.map((item: Record<string, any>) => {
        const carrierWiseBookings = item?.carrierWiseBookings?.map((carrierItem: Record<string, any>) => ({
            ...carrierItem,
            percentage: parseFloat(carrierItem.percentage.toFixed(1))
        }))

        return {
            ...item,
            carrierWiseBookings,
            percentageWidth: parseFloat(((item.totalBooking / maxTotalBooking) * 100).toFixed(1))
        }
    })

    return result
}

export const extractMyCarrierData = (response: Array<Record<string, any>>) => {
    if (!response || response.length === 0) return []

    const totalStatuses = response.length
    const approvedStatuses = response.filter((dataItem: any) => dataItem.status === 'Approved').length
    const percentageApproved = ((approvedStatuses / totalStatuses) * 100).toFixed(0)

    return {
        percentageApproved,
        data: _.sortBy(_.uniqBy(response, 'carrier'), 'carrier')
    }
}

export const getCarrierImagePath = (logos: object, carrier: string) => getLogoByCarrier(logos, carrier)
